<template>
    <div class="container pt-5 pb-5">
    <address>
        <router-link :to="{ name: 'Index'}" class="brand">
            VEILIGHEIDS<span class="primary">TEAM</span>.NL
        </router-link><br />
        Endegeesterstraatweg 3<br />
        2342 AJ OEGSTGEEST<br />
        <br />
        <abbr title="WhatsApp" class="primary"><font-awesome-icon :icon="['fab', 'whatsapp']"></font-awesome-icon></abbr>&nbsp;<a href="https://wa.me/31640000933" target="_blank">06-40000933</a><br />
        <abbr title="Email" class="primary"><font-awesome-icon icon="envelope"></font-awesome-icon></abbr>&nbsp;<a href="mailto:info@veiligheidsteam.nl">info@veiligheidsteam.nl</a><br />
    </address>
    <hr class="mt-5 mb-5" />
        <h3 class="text-muted">Neem vrijblijvend contact met ons op en vraag naar de mogelijkheden!</h3>
        <contact-form class="mt-5"></contact-form>
    </div>
</template>

<script>
import ContactForm from '@/components/ContactForm'
export default {
    components: {
        ContactForm
    }
}
</script>

<style scoped>
</style>